type Callback = (...args: any[]) => void;

class PubSub {
    subscribers: { [eventName: string]: Callback[] };

    constructor() {
        this.subscribers = {};
    }

    subscribe(eventName: string, callback: Callback): void {
        if (!this.subscribers[eventName]) {
            this.subscribers[eventName] = [];
        }
        this.subscribers[eventName].push(callback);
    }

    unsubscribe(eventName: string): void {
        if (this.subscribers[eventName]) {
            delete this.subscribers[eventName];
        }
    }

    publish(eventName: string, ...args: any[]): void {
        const eventSubscribers = this.subscribers[eventName];

        if (eventSubscribers) {
            eventSubscribers.forEach(callback => {
                callback(...args);
            });
        }
    }
}

export default PubSub;
